module.exports = __webpack_public_path__ + "img/star-fill.6f524816.svg";